import { NEW_NON_MESSAGE_NOTIFICATION } from "../actions/actions";

const newNonMessageNotifications = (payload) => {
  return {
    type: NEW_NON_MESSAGE_NOTIFICATION,
    payload: payload,
  };
};

export default newNonMessageNotifications;
